import { Pipe, PipeTransform } from '@angular/core';
import { EventStatus, League } from '@model';

@Pipe({ name: 'leagueEventsToGo' })
export class LeagueEventsToGoPipe implements PipeTransform {
  transform = (value?: League): number => value ? this.calculateEventsToGo(value) : 0;

  private calculateEventsToGo = (league?: League): number =>
    league?.events?.reduce((count, item) => item.status === EventStatus.ACTIVE ? count + 1 : count, 0) ?? 0;
}
